/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';

// import report
import ListReportEdc from '../views/fee-management/ListFeeManagement.vue';
import { setBreadcrumb } from './index';

const feeManagementRoute = {
  path: '/fee-management',
  children: [
    {
      path: '',
      meta: {
        title: 'BNI QRIS - Fee Management',
        appBarTitle: 'Fee Management',
        breadcrumbs: () => [
          setBreadcrumb('Fee Management', '/fee-management', true),
          setBreadcrumb('List Fee Management', '/fee-management'),
        ],
      },
      component: ListReportEdc,
      name: 'ListFeeManagement',
    },
  ],

  meta: {
    title: 'BNI QRIS - Fee Management',
    appBarTitle: 'Fee Management',
  },
  component: Parent,
};
export default feeManagementRoute;
